<template>
  <Card size="large" id="pd-auto-update">
    <View direction="column" justify="center" gap="xs" class="auto-update">
      <View justify="space-between" align="center" gap="md">
        <View gap="xs" align="center">
          <Text variant="label-medium">Listing optimization</Text>
          <div class="tooltip-container">
            <Tooltip
              icon-size="extra-small"
              content="Tallo will automatically make slight changes to your listing to refresh it and maintain top position in search results. This feature only works for properties syndicated through Tallo"
            />
          </div>
        </View>
        <Switch variant="brand" v-model="isAutoUpdateEnabled" />
      </View>
      <Text variant="body-medium" color="tertiary">Automatically refreshes to keep listing top-ranked</Text>
      <Text variant="body-small" color="tertiary">{{ lastUpdatedText }}</Text>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { useTimeAgo } from '@vueuse/core';
import { computed } from 'vue';

import { Card, Switch, Text, Tooltip, View } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';
import { useTimeAgoShortMessages } from '@tallo/utility';

const propertyStore = usePropertyStore();

const isAutoUpdateEnabled = computed({
  get: () => propertyStore.property?.autoRefresh ?? false,
  set: (value: boolean) => {
    propertyStore.toggleAutoRefresh(value);
  },
});

const lastUpdatedText = computed(() => {
  const lastListedAt = propertyStore.property?.lastListedAt;
  const lastUpdatedAt = propertyStore.property?.updatedAt;

  if (!lastListedAt || !lastUpdatedAt) {
    return 'Never refreshed';
  }

  const timeAgo = useTimeAgo(lastUpdatedAt, { messages: useTimeAgoShortMessages });
  return `Refreshed ${timeAgo.value}`;
});
</script>

<style scoped lang="scss">
.auto-update {
  height: 100%;
}

.tooltip-container {
  width: 1rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
